import React, { useState, useEffect, useRef } from 'react';

interface Comment {
  id: string;
  text: string;
}

interface CommentItemProps {
  comment: Comment;
}

export const CommentItem: React.FC<CommentItemProps> = ({ comment }) => {
  const [hovered, setHovered] = useState(false);
  const commentRef = useRef<HTMLDivElement>(null);
  // Сохраним найденный mark-элемент в ref,
  // чтобы не выполнять его поиск каждый раз при срабатывании событий.
  const markElementRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    // Находим mark-элемент по data-id, соответствующему id комментария
    markElementRef.current = document.querySelector(`mark[data-id="${comment.id}"]`);

    const markEl = markElementRef.current;

    if (!markEl) {
      return;
    }
    // Когда наводят курсор на mark, выделяем комментарий (например, добавляем обводку)
    const handleMarkMouseEnter = () => setHovered(true);
    const handleMarkMouseLeave = () => setHovered(false);

    markEl.addEventListener('mouseenter', handleMarkMouseEnter);
    markEl.addEventListener('mouseleave', handleMarkMouseLeave);

    // Очистка обработчиков при размонтировании
    return () => {
      markEl.removeEventListener('mouseenter', handleMarkMouseEnter);
      markEl.removeEventListener('mouseleave', handleMarkMouseLeave);
    };
  }, [comment.id]);

  // При наведении на сам комментарий подсвечиваем связанный mark
  const handleMouseEnter = () => {
    setHovered(true);
    if (markElementRef.current) {
      markElementRef.current.style.outline = '1px solid blue';
    }
  };

  const handleMouseLeave = () => {
    setHovered(false);
    if (markElementRef.current) {
      markElementRef.current.style.outline = 'none';
    }
  };

  return (
    <div
      ref={commentRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        border: hovered ? '1px solid blue' : '1px solid lightgrey',
        padding: '8px',
        marginBottom: '4px',
      }}
    >
      {comment.text}
    </div>
  );
};
